import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import SectionHead from "./SectionHead";
import { waLink } from "@/lib/site";

export default function Packages({ packages }) {
  return (
    <section id="packages" data-testid="featured-packages-section" className="bg-[#0B1014] py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <SectionHead
          overline="Featured packages"
          title="Odisha, the way it deserves to be seen"
          sub="Fixed circuits or fully customised — every package includes vehicle, driver and planning."
        />
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {packages.map((p, i) => (
            <motion.article
              key={p.id}
              data-testid={`package-card-${p.slug}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="gold-glow-hover group flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#171F26]"
            >
              <a href={`/packages/${p.slug}`} data-testid={`package-view-${p.slug}`} className="block">
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.alt || p.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-[#0F1418]/80 px-3 py-1 text-xs text-[#D4AF37] backdrop-blur-sm">
                    <Clock className="h-3 w-3" /> {p.duration}
                  </span>
                </div>
                <div className="px-6 pt-6">
                  <h3 className="font-serif text-lg font-semibold leading-snug transition-colors group-hover:text-[#D4AF37]">{p.name}</h3>
                  <ul className="mt-4 space-y-1.5">
                    {(p.points || []).map((pt) => (
                      <li key={pt} className="flex items-start gap-2 text-sm text-white/60">
                        <span className="mt-1.5 h-1 w-1 shrink-0 rotate-45 bg-[#D4AF37]" /> {pt}
                      </li>
                    ))}
                  </ul>
                </div>
              </a>
              <div className="mt-auto flex items-center justify-between px-6 pb-6 pt-6">
                <a href={`/packages/${p.slug}`} className="flex items-center gap-1.5 text-sm font-medium text-white/70 transition-colors hover:text-white">
                  View itinerary <ArrowUpRight className="h-4 w-4" />
                </a>
                <a
                  href={waLink(`Hello Jay Jagannath Tour & Travels, I want to book the "${p.name}" package (${p.duration}). Please share details.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`package-book-${p.slug}`}
                  className="text-sm font-medium text-[#D4AF37] transition-colors hover:text-white"
                >
                  Book
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
